module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Purchased: His Perfect Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tit"
    }
  }, [_c('h2', {
    staticClass: "titlePageAuthor"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Helen Bianchin")])])])])]), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("PURCHASED: HIS PERFECT WIFE")])])]), _c('p', {
    staticClass: "CenterImage1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/sub.jpg"
    }
  })])]), _c('p', {
    staticClass: "titlepageLogo"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/logo.jpg"
    }
  })])]), _c('p', {
    staticClass: "titlePageCity"
  }, [_c('span', [_vm._v("TORONTO • NEW YORK • LONDON"), _c('br'), _vm._v("\nAMSTERDAM • PARIS • SYDNEY • HAMBURG"), _c('br'), _vm._v("\nSTOCKHOLM • ATHENS • TOKYO • MILAN • MADRID"), _c('br'), _vm._v("\nPRAGUE • WARSAW • BUDAPEST • AUCKLAND")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b0b226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchasedhisperfectwife_tit.vue
// module id = 66
// module chunks = 0